import { useState, useEffect } from 'react';
import { useEmployeeNamesService } from 'domain/shared/employee';

interface EmployeeData {
  nameEn?: {
    firstName?: string;
    lastName?: string;
    maidenName?: string;
  };
  workingEmail?: string;
  mainPhotoId?: string;
}

const useEmployeeData = (employeeId?: string) => {
  const { getEmployeeNameDataById, getEmployeeAvatarDataById, getEmployeeWorkingEmailDataById } =
    useEmployeeNamesService();

  const [data, setData] = useState<EmployeeData | null>(null);
  const [loading, setLoading] = useState<boolean>(!!employeeId);

  useEffect(() => {
    if (!employeeId) {
      setLoading(false);
      setData(null);
      return;
    }

    const fetchData = async () => {
      try {
        const [nameData, avatarData, emailData] = await Promise.all([
          getEmployeeNameDataById(employeeId),
          getEmployeeAvatarDataById(employeeId),
          getEmployeeWorkingEmailDataById(employeeId),
        ]);

        setData({
          nameEn: nameData?.nameEn
            ? {
                firstName: nameData.nameEn.firstName,
                lastName: nameData.nameEn.lastName,
                maidenName: nameData.nameEn.maidenName,
              }
            : undefined,
          workingEmail: emailData?.workingEmail,
          mainPhotoId: avatarData?.mainPhotoId,
        });
      } catch (error) {
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId]);

  return { data, loading };
};

export default useEmployeeData;
export type { EmployeeData };
